module.exports = __webpack_public_path__ + "img/GBP.7f82ab66.png";